import { useMsal } from '@azure/msal-react';
import type { IPublicClientApplication } from '@azure/msal-browser';

/**
 * Returns the shared MSAL public client application instance.
 */
const useMsalInstance = (): IPublicClientApplication => {
  const { instance } = useMsal();
  return instance;
};

export default useMsalInstance;
